import React from 'react';
import PropTypes from 'prop-types';
import { KebabMenu } from '@metarouter-private/mr-mui';

export default function AnalyticsBuilderKebabMenu({ onDownload, onUpload }) {
  const menuItems = [
    {
      label: 'Download as YAML',
      onClick: onDownload,
      testId: 'download-yaml-menu-item',
    },
    {
      label: 'Upload from YAML',
      onClick: onUpload,
      testId: 'upload-yaml-menu-item',
    },
  ];

  return <KebabMenu items={menuItems} testId="analytics-builder-kebab-menu" />;
}

AnalyticsBuilderKebabMenu.propTypes = {
  onDownload: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
};
